import request from "@/utils/request"

// 加载表格数据
export function getProductList(params) {
  return request({
    url: "/server/amazon/product/list",
    method: "get",
    params: params,
  })
}

// 查询汇出Amazon列表
export function getRemitList(params) {
  return request({
    url: "/server/amazon/product/listRemit",
    method: "get",
    params: params,
  })
}

// 获取Amazon产品信息详细信息
export function getProductInfo(params) {
  return request({
    url: "/server/amazon/product/getInfo/" + params,
    method: "get",
  })
}

//新增Amazon产品信息
export function addProduct(params) {
  return request({
    url: "/server/amazon/product/add",
    method: "POST",
    data: params,
  })
}

// 汇出Amazon产品信息
export function addRemit(data) {
  return request({
    url: "/server/amazon/product/addRemit",
    method: "POST",
    data: data,
  })
}

//下载汇出Amazon产品信息
export function exportRemit(params) {
  return request({
    url: "/server/amazon/product/exportRemit",
    method: "POST",
    data: params,
  })
}

//删除Amazon产品信息
export function deleteProduct(params) {
  return request({
    url: "/server/amazon/product/delete/" + params,
    method: "POST",
  })
}

//复制Amazon产品信息
export function copyProduct(params) {
  return request({
    url: "/server/amazon/product/copy/" + params,
    method: "POST",
  })
}
